"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.podcastOpmlParser = void 0;
const constants_1 = require("../constants");
const transform_1 = require("../transform");
/**
 * Parses an OPML feed and returns an array of podcast feed URLs.
 *
 * @param source - A URL or XML string representing the OPML feed.
 * @returns An array of feed URLs extracted from the OPML data.
 * @throws If the source type is invalid or no feed is available to parse.
 */
const podcastOpmlParser = (source) => __awaiter(void 0, void 0, void 0, function* () {
    let xmlText = "";
    if (source instanceof URL) {
        const response = yield fetch(source.toString());
        if (!response.ok) {
            throw new Error(constants_1.ERROR_MESSAGES.FETCH_FAILED);
        }
        xmlText = yield response.text();
    }
    else if (typeof source === "string") {
        xmlText = source;
    }
    else {
        throw new Error(constants_1.ERROR_MESSAGES.OPML_INVALID_SOURCE);
    }
    if (!xmlText) {
        throw new Error(constants_1.ERROR_MESSAGES.OPML_NO_FEED_TO_PARSE);
    }
    return (0, transform_1.transformOpml)(xmlText);
});
exports.podcastOpmlParser = podcastOpmlParser;
